import React from 'react'

interface FormActionHandlers {
  [key: string]: (props: any) => void
}

interface FormContextType {
  network: any
  formTitle: string
  currentStep: number
  sectionsNumber: number
  generatePDF: () => React.ReactElement | null
  actionHandlers: FormActionHandlers
  mainConnectedObject: 'Opportunity' | 'Case'
  formViewType: 'editable' | 'printable' | 'pdf' | 'fillable-pdf'
}

const FormContext = React.createContext<FormContextType>({
  network: null,
  formTitle: '',
  currentStep: 0,
  sectionsNumber: 1,
  generatePDF: () => null,
  actionHandlers: {},
  mainConnectedObject: '',
  formViewType: 'editable'
})

export function useFormContext (): FormContextType {
  const value = React.useContext(FormContext)
  if (!value) {
    throw new Error('useSession must be wrapped in a <SessionProvider />')
  }
  return value
}

export function FormContextProvider (
  props: React.PropsWithChildren<FormContextType>
): React.Provider<FormContextType> {
  return (
    <FormContext.Provider
      value={{
        ...props
      }}
    >
      {props.children}
    </FormContext.Provider>
  )
}
